var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
var SvgIconmedium = function SvgIconmedium(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 12,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.897 2.448a.568.568 0 00-.202-.494L.202.254V0h4.639l3.585 7.429L11.578 0H16v.254L14.723 1.41a.344.344 0 00-.142.339v8.501a.344.344 0 00.142.338l1.247 1.157V12H9.695v-.254l1.293-1.185c.127-.12.127-.155.127-.338V3.35l-3.593 8.621h-.485l-4.184-8.62v5.777a.77.77 0 00.232.663l1.68 1.926v.254H0v-.254l1.68-1.926a.74.74 0 00.217-.663V2.45z",
    fill: "#c4c4c4"
  })));
};
export default SvgIconmedium;